import { React, useState } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Radio
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../pageStyled";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import warning from "../../../Assets/Icons/warning.png"
import {ModalPopup} from "../../../Components/Modal/modal";

const { Option } = Select;
const userTypeData = ["Admin", "Basic"];
const provinceData = ["India", "USA"];

const userStatusData = [
  { label: "Active", value: "Active" },
  { label: "Disabled", value: "Disabled" },
];

const cityData = {
  India: ["Arunachal Pradesh", "Andra Pradesh", "Bihar", "Chhattisgarh"],
  USA: ["Arizona", "California", "Colorado"],
};
const { TextArea } = Input;

const AddNewCustomer = (props) => {
  const [cities, setCities] = useState(cityData[provinceData[0]]);
  const [secondCity, setSecondCity] = useState(cityData[provinceData[0]][0]);
  const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [checkedBox, setCheckedBox] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isOfficeCountryDropdownOpen, setOfficeCountryDropdown] = useState(false);
  const [isOfficeStateDropdownOpen, setOfficeStateDropdown] = useState(false);
  const [isDeliveryCountryDropdownOpen, setDeliveryCountryDropdown] = useState(false);
  const [isDeliveryStateDropdownOpen, setDeliveryStateDropdown] = useState(false);
  
  const OnOfficeCountryToggleSelect =()=>{
    setOfficeCountryDropdown((prevState) => !prevState
  )
  }

  const OnOfficeStateToggleSelect =()=>{
    setOfficeStateDropdown((prevState) => !prevState
  )
  }

  const OnDeliveryCountryToggleSelect =()=>{
    setDeliveryCountryDropdown((prevState) => !prevState
  )
  }

  const OnDeliveryStateToggleSelect =()=>{
    setDeliveryStateDropdown((prevState) => !prevState
  )

  }

  const modalShow = () => {
    setIsVisibleModal(true);
  };

  const modalClose = () => {
    setIsVisibleModal(false);
  };

  const modalConfirm = () => {
    setIsVisibleModal(false);
  }
  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);
  };
  const handleStatusChange = (e) => {
    //console.log('radio checked', e.target.value);
    setUserStatus(e.target.value);
  };
  const handleProvinceChange = (value) => {
    setCities(cityData[value]);
    setSecondCity(cityData[value][0]);
  };

  const onSecondCityChange = (value) => {
    setSecondCity(value);
  };
  const getFlag = (short) => {
    const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
    // for dumi
    if (typeof data === "string") {
      return data;
    }
    // for CRA
    return data.default;
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Fun Flips PVT LTD"
          extra={[
            <Button key="3" className="textTypeBtn">Cancel changes</Button>,
            <Button key="2" className="themeBtn noBg" onClick={modalShow}><Iconmoon icon="delete" size={14} color="#EA655B" />Delete User</Button>,
            <Button key="1" className="themeBtn"><Iconmoon icon="edit" size={14} color="#ffffff" />Edit User</Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details will be used in order records and
                      reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer Code</label>
                        <p>This is an auto generated code</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="Customer Code"
                          rules={[{ required: true }]}
                          className=""
                        >
                          <Input
                            disabled
                            defaultValue="HW19092021"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer Name</label>
                        <p>The customer will be identified by this name</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="Customer Name"
                          rules={[{}]}
                          className=""
                        >
                          <Input
                            placeholder="Enter name of the customer"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer Alias</label>
                        <p>
                          An alternate short name used to identify this customer
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item name="Customer Alias" rules={[{}]} className="">
                          <Input
                            placeholder="Enter alias of the customer"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Type of Customer</label>
                        <p>Customer can be a dealer or a direct customer </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Select
                          placeholder="Select"
                          suffixIcon={<DownArrowDraw />}
                          defaultValue={userTypeData[0]}
                        >
                          {userTypeData.map((userType) => (
                            <Option key={userType}>{userType}</Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          GST Number <span>(Optional)</span>
                        </label>
                        <p>GST identification number of customer (GSTIN)</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item name="Gst" rules={[{}]} className="">
                          <Input
                            placeholder="Enter GST Number"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          PAN Number<span>(Optional)</span>
                        </label>
                        <p>10 Digit PAN number of the customer</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item name="Pan number" rules={[{}]} className="">
                          <Input
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Date of Dealership <span>(Optional)</span>
                        </label>
                        <p>
                          The date on which dealership certificate was issued
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item name="Date">
                            <DatePicker format={"DD/MM/YYYY"} />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Contact Details</h2>
                    <p>
                      The contsct details will be used to contact this customer
                      for support and automatic emails
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Contact Person<span> (Optional)</span>
                        </label>
                        <p>Mill can contact this person for support</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="contactperson"
                          rules={[{}]}
                          className=""
                        >
                          <Input
                            placeholder="Enter name of the contact person"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Primary Contact Number</label>
                        <p>
                          Mill can use this number as primary contact number
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <ConfigProvider
                          locale={en}
                          areaMapper={(area) => {
                            return {
                              ...area,
                              emoji: (
                                <img
                                  alt="flag"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    verticalAlign: "sub",
                                  }}
                                  src={getFlag(area.short)}
                                />
                              ),
                            };
                          }}
                        >
                          <CountryPhoneInput
                            className="intlPhone"
                            placeholder="Enter the contact number"
                            defaultValue={{ short: "IN" }}
                          />
                        </ConfigProvider>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Alternate Contact Number<span> (Optional)</span>
                        </label>
                        <p>
                          Mill can use this number as alternate contact number
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <ConfigProvider
                          locale={en}
                          areaMapper={(area) => {
                            return {
                              ...area,
                              emoji: (
                                <img
                                  alt="flag"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    verticalAlign: "sub",
                                  }}
                                  src={getFlag(area.short)}
                                />
                              ),
                            };
                          }}
                        >
                          <CountryPhoneInput
                            className="intlPhone"
                            placeholder="Enter the alternate contact number"
                            defaultValue={{ short: "IN" }}
                          />
                        </ConfigProvider>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Primary Email ID</label>
                        <p>
                          Mill can use this email as primary mode of contact
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="primaryemail"
                          rules={[{ required: true, type: "email" }]}
                          className=""
                        >
                          <Input placeholder="Enter the email id" />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Secondary Email ID<span> (Optional)</span>
                        </label>
                        <p>
                          Mill can use this email as alternate mode of contact
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="alternateemail"
                          rules={[{}]}
                          className=""
                        >
                          <Input placeholder="Enter the alternate email id" />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Office Address</h2>
                    <p>
                    The address of the customer’s office
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Complete Office Address</label>
                        <p>
                        The complete postal office address of the customer
                        </p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <Form.Item
                          name="Contactaddress"
                          rules={[{ required: true }]}
                          className=""
                        >
                          <DisabledStyles>
                            <Input
                              className="disabled-check"
                              placeholder="First Line of address"
                            />
                          </DisabledStyles>
                        </Form.Item>
                      </div>

                      <div className="boxFormType">
                        <Form.Item
                          name="contact address"
                          rules={[{}]}
                          className=""
                        >
                          <DisabledStyles>
                            <Input
                              className="disabled-check"
                              placeholder="Second Line of address"
                            />
                          </DisabledStyles>
                        </Form.Item>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Select className="disabled-check"
                             suffixIcon={ isOfficeCountryDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                             onBlur = {OnOfficeCountryToggleSelect}
                             onFocus = {OnOfficeCountryToggleSelect}
                             showSearch
                             optionFilterProp="children"
                             filterOption={(input, option) => 
                               option.children.toLowerCase().
                               includes(input.toLowerCase())}
                              defaultValue={provinceData[0]}
                              onChange={handleProvinceChange}
                            >
                              {provinceData.map((province) => (
                                <Option key={province}>{province}</Option>
                              ))}
                            </Select>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Select
                              suffixIcon={ isOfficeStateDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                              onBlur = {OnOfficeStateToggleSelect}
                              onFocus = {OnOfficeStateToggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) => 
                                option.children.toLowerCase().
                                includes(input.toLowerCase())}
                              value={secondCity}
                              onChange={onSecondCityChange}
                            >
                              {cities.map((city) => (
                                <Option key={city}>{city}</Option>
                              ))}
                            </Select>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name="City"
                            rules={[{ required: true }]}
                            className=""
                          >
                            <DisabledStyles>
                              <Input
                                placeholder="City"
                                className="disabled-check"
                              />
                            </DisabledStyles>
                          </Form.Item>
                        </div>
                        <div className="boxFormType">
                          <Form.Item
                            name="Zip code"
                            rules={[{ required: true }]}
                            className=""
                          >
                            <DisabledStyles>
                              <Input
                                className="disabled-check"
                                placeholder="ZIP code"
                              />
                            </DisabledStyles>
                          </Form.Item>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Delivery Address</h2>
                    <p>
                      The order of this customer will be delivered at this
                      address
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Building Number and Street Address</label>
                        <p>
                          The complete postal address of the customer which can
                          be used to deliver goods
                        </p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <Form.Item
                          name="Contactaddress"
                          rules={[{ required: true }]}
                          className=""
                        >
                          <GlobalSet>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={checkedBox}
                                onChange={onChangeHandlerBox}
                              />
                              <p>Delivery address is same as office address</p>
                            </div>
                          </GlobalSet>
                          <DisabledStyles>
                            <Input
                              disabled={checkedBox}
                              className="disabled-check"
                              placeholder="First Line of address"
                            />
                          </DisabledStyles>
                        </Form.Item>
                      </div>

                      <div className="boxFormType">
                        <Form.Item
                          name="contact address"
                          rules={[{}]}
                          className=""
                        >
                          <DisabledStyles>
                            <Input
                              disabled={checkedBox}
                              className="disabled-check"
                              placeholder="Second Line of address"
                            />
                          </DisabledStyles>
                        </Form.Item>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Select className="disabled-check"
                              disabled={checkedBox}
                              suffixIcon={ isDeliveryCountryDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                                onBlur = {OnDeliveryCountryToggleSelect}
                                onFocus = {OnDeliveryCountryToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => 
                                  option.children.toLowerCase().
                                  includes(input.toLowerCase())}
                              defaultValue={provinceData[0]}
                              onChange={handleProvinceChange}
                            >
                              {provinceData.map((province) => (
                                <Option key={province}>{province}</Option>
                              ))}
                            </Select>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Select
                              disabled={checkedBox}
                              suffixIcon={ isDeliveryStateDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                              onBlur = {OnDeliveryStateToggleSelect}
                              onFocus = {OnDeliveryStateToggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) => 
                                option.children.toLowerCase().
                                includes(input.toLowerCase())}
                              value={secondCity}
                              onChange={onSecondCityChange}
                            >
                              {cities.map((city) => (
                                <Option key={city}>{city}</Option>
                              ))}
                            </Select>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name="City"
                            rules={[{ required: true }]}
                            className=""
                          >
                            <DisabledStyles>
                              <Input
                                placeholder="City"
                                disabled={checkedBox}
                                className="disabled-check"
                              />
                            </DisabledStyles>
                          </Form.Item>
                        </div>
                        <div className="boxFormType">
                          <Form.Item
                            name="Zip code"
                            rules={[{ required: true }]}
                            className=""
                          >
                            <DisabledStyles>
                              <Input
                                disabled={checkedBox}
                                className="disabled-check"
                                placeholder="ZIP code"
                              />
                            </DisabledStyles>
                          </Form.Item>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to this customer</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Status</label>
                        <p>
                          The order for this customer will only be recorded if
                          it's enabled
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={userStatusData}
                          onChange={handleStatusChange}
                          value={userStatus}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>Extra information of this customer</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="Business Owner"
                            rules={[{ required: true }]}
                            className=""
                          >
                            <TextArea
                              maxLength={100}
                              style={{ height: 90 }}
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete Customer?</span>
          <p>
            A customer deleted once cannot be recovered. Are you sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button key="back" className="themeBtn-plane" onClick={() => modalClose()}>
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button key="submit" className="themeBtn" onClick={() => modalConfirm()} >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

    </RightLayoutContainer>
  );
};

export default AddNewCustomer;
